var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-app-bar'),(_vm.$store.state.keyDrawer > 0)?_c('dashboard-core-drawer',{key:_vm.$store.state.keyDrawer}):_vm._e(),_c('dashboard-core-view'),_c('chat-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }